export const Gutenberg = [
    {
        "Text": {
            "Name": "Text",
            "data": [{ "Text": "Text" }, { "Textarea": "Textarea" }, { "GroupPopover": "Popover" }, { "Media": "Media" }, { "Repeater": "Repeater" }, { "Number": "Number" }, { "TextShadow": "TextShadow" }, { "Toggle": "Switcher" }, { "Background": "Background" }, { "Border": "Border" }, { "BoxShadow": "BoxShadow" }, { "Color": "Color" }, { "FilterCss": "CssFilter" }, { "Dimension": "Dimension" }, { "Gallery": "Gallery" }]
        },

        "Number": {
            "Name": "Number",
            "data": [{ "URL": "URL" }, { "Typography": "Typography" }, { "NormalHover": "NormalHover" }, { "IconList": "IconsControl" }, { "LableHeading": "Heading" }, { "Gradientcolor": "Gradientcolor" }, { "Note": "RawHTML" }]
        },

        "Image": {
            "Name": "Image",
            "data": [{ "RadioAdvanced": "choose" }, { "Range": "Slider" }, { "Headingtags": "Headingtags" }, { "Select": "Select" }]
        },
    },
]

export const Elementor = [
    {
        "DataControls": {
            "Name": "Data Controls",
            "data": [{ "Text": "Text" }, { "Number": "Number" }, { "Textarea": "Textarea" }, { "WYSIWYG": "WYSIWYG" }, { "Switcher": "Switcher" }, { "Popover": "Popover" }, { "Select": "Select" }, { "Select2": "Select2" }, { "Choose": "Choose" }, { "Color": "Color" }, { "DateTime": "DateTime" }, { "Gallery": "Gallery" }, { "Repeater": "Repeater" }]
        },
        "WDesignKitControls": {
            "Name": "WDsignKit Controls",
            "data": [{ "SelectTemplate": "SelectTemplate" }]
        },
        "Multivalue Controls": {
            "Name": "Multivalue Controls",
            "data": [{ "URL": "URL" }, { "Media": "Media" }, { "IconsControl": "IconsControl" }, { "Headingtags": "Headingtags" }]
        },
        "Unit Controls": {
            "Name": "Unit Controls",
            "data": [{ "Slider": "Slider" }, { "Dimension": "Dimension" }, { "NormalHover": "NormalHover" }]
        },
        "UI Controls": {
            "Name": "UI Controls",
            "data": [{ "Heading": "Heading" }, { "RawHTML": "RawHTML" }, { "Divider": "Divider" }]
        },
        "Group Controls": {
            "Name": "Group Controls",
            "data": [{ "Typography": "Typography" }, { "TextShadow": "TextShadow" }, { "BoxShadow": "BoxShadow" }, { "Border": "Border" }, { "Background": "Background" }, { "CssFilter": "CssFilter" }]
        }
    }
];